<template>
  <span
    class="image-container"
    :id="content.key"
    :style="{
      float: content.position == 'left' ? 'left' : content.position == 'right' ? 'right' : '',
      verticalAlign: content.verticalAlign || ''
    }"
  >
    <!-- <img
      :id="`${content.key}-1`"
      :src="content.url"
      :style="{
        display: content.position == 'inline' ? 'inline-block' : '',
        width: content.width ? content.width + 'rem' : ''
      }"
      alt=""
      class="image"> -->
    <el-image
      :id="`${content.key}-1`"
      :src="content.url"
      :style="{
        display: content.position == 'inline' ? 'inline-block' : '',
        width: content.width ? content.width + 'rem' : ''
      }"
      alt=""
      class="image"
      :preview-src-list="[content.url]"
    ></el-image>
  </span>
</template>
<script>
/*
图片
*/
export default {
  name: "text-image",
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.image-container{
  display: inline-block;
  cursor: pointer;
  text-indent: 0;
  vertical-align: baseline;

  .image{
    display: inline-block;
    max-width: 100%;
    vertical-align: middle;
  }
}
/deep/.el-image{
  .el-image__inner{
    vertical-align: middle;
    display: block;
    overflow: hidden;
  }
}
</style>